/**
 * Monotonic run identity: an async flow captures `begin()`'s id and checks
 * `isCurrent(id)` after each await — a newer run or a `cancel()` makes every
 * older id stale, so a superseded flow stops side-effecting (navigation,
 * closing the overlay) without needing to abort the underlying request.
 */
export const createRunTracker = () => {
  let current = 0;
  return {
    begin: () => ++current,
    isCurrent: (id: number) => id === current,
    cancel: () => {
      current += 1;
    },
  };
};
